import React from 'react';

import { useIntl } from 'react-intl';

import { ILoyaltyTransaction } from '@rbi-ctg/menu';

import {
  Divider,
  StyledLoyaltyPointsIcon,
  Total,
  TotalLabel,
  TotalsRow,
} from './modal-order-details.styled';

export const OrderRewardDetails = ({
  loyaltyTransaction,
}: {
  loyaltyTransaction: ILoyaltyTransaction;
}) => {
  const { formatMessage } = useIntl();
  const { pointsBalance, pointsUsed } = loyaltyTransaction;

  return (
    <>
      {/* Available Points */}
      <TotalsRow>
        <TotalLabel focusable>{formatMessage({ id: 'availablePoints' })}</TotalLabel>
        <Total marginRight="$1" focusable>
          {pointsBalance}
        </Total>
        <StyledLoyaltyPointsIcon />
      </TotalsRow>

      {/* Redeeming */}
      <TotalsRow marginTop="$2">
        <TotalLabel focusable>{formatMessage({ id: 'redeeming' })}</TotalLabel>
        <Total marginRight="$1" focusable>
          {-(pointsUsed || 0)}
        </Total>
        <StyledLoyaltyPointsIcon />
      </TotalsRow>

      <Divider />
    </>
  );
};
